/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React, { memo } from 'react';

import { useNoItemsTextStyles } from './NoItemsText.styles';

type NoItemTextProps = {
  title: string;
  className?: string;
};

export const NoItemsText = memo<NoItemTextProps>(props => {
  const { title, className } = props;
  const classes = useNoItemsTextStyles();

  return <div className={cx(classes.root, className)}>{title}</div>;
});
